import React, {Component, Fragment} from 'react';
import {Redirect} from "react-router";
import { Trans, withTranslation } from 'react-i18next';

import ContactsForm from "./Parts/ContactsForm";
import AppContext from "../../contexts/AppContext";

class Contacts extends Component {

    static contextType = AppContext;

    constructor(props){
        super(props);

        this.state = {
            redirectToNextStep : false
        };

        this.formSubmit = this.formSubmit.bind(this);
    }

    formSubmit(values, actions) {
        const { clearError } = this.context;

        clearError();

        axios.post('/api/process/' + this.props.application_token + '/contacts', values)
            .then(
                data => {
                    actions.setSubmitting(false);

                    if(data.data.status === 'success') {
                        this.setState({ redirectToNextStep: true });
                    }
                },
                error => {
                    let response_data = error.response.data;

                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                    actions.setStatus({
                        msg: response_data.message,
                        code: response_data.code,
                    });
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    render() {
        if (this.state.redirectToNextStep) {
            return <Redirect push={true} to={'/' + this.props.application_token + '/process/incomes'} />
        }

        return (
            <ContactsForm
                suggestion={this.props.suggestion}
                data={this.props.data}
                submitFunction={this.formSubmit}
            />
        )
    }
}

export default withTranslation()(Contacts);
